import { render, staticRenderFns } from "./OrganizationCreateLinkTeams.vue?vue&type=template&id=0a1146ba&scoped=true&"
import script from "./OrganizationCreateLinkTeams.vue?vue&type=script&lang=ts&"
export * from "./OrganizationCreateLinkTeams.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationCreateLinkTeams.vue?vue&type=style&index=0&id=0a1146ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1146ba",
  null
  
)

export default component.exports